/**
 * Site Buttons
 * 
 * Initialize site buttons with data-text attribute
*/


function initSiteButtons() {
    document.querySelectorAll('.wp-block-button.is-style-fill > .wp-element-button').forEach(btn => {
        btn.setAttribute('data-text', btn.textContent.trim());
    });
}

document.addEventListener('DOMContentLoaded', initSiteButtons);